/* eslint-disable no-param-reassign */
/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import Swal from 'sweetalert2';
import { cpf } from 'cpf-cnpj-validator';

import { useHistory, useLocation, useParams } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import axios from 'axios';
import { Container } from './styles';
import { KrUserDocument } from '~/components/KoroIcons';
import ButtonBack from '~/components/ButtonBack';

import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import Loading from '~/components/Loading';
import ButtonHome from '~/components/ButtonHome';
import Input from '~/components/Input';
import InputMask from '~/components/InputMask';
import InputRadio, { IOption } from '~/components/InputRadio';
import { useAuth } from '~/hooks/Auth';
import Toast from '~/utils/toast';
import { useCart } from '~/hooks/Cart';
import formatDate from '~/utils/formatDate';

interface IParams {
  slug: string;
}

interface IFormData {
  id: number;
  name: string;
  email: string;
  document?: string;
  phone?: string;
  birthdate?: string;
  gender?: string;
  address_id?: number;
  zipcode?: string;
  street?: string;
  number?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  complement?: string;
}

interface IParams {
  slug: string;
  preview: string;
}

const PersonalData: React.FC = () => {
  const location = useLocation();
  const { user, updateUser } = useAuth();
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();
  const params = useParams<IParams>();
  const { cart, setFillBefore } = useCart();
  const [sending, setSending] = useState(false);
  const [documentError, setDocumentError] = useState('');
  const [sizesLoaded, setSizesLoaded] = useState(true);
  const [banner, setBanner] = useState('');
  const [userData, setUserData] = useState({} as IFormData);
  const [genderSelected, setGenderSelected] = useState({} as IOption);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    api
      .get(`events/${params.slug}`)
      .then((response) => {
        setFillBefore(response.data.fill_before);
        setBanner(response.data.archivesEvents[0].archive.archive_url);
      })
      .finally(() => setSizesLoaded(false));
  }, [params.slug, setFillBefore]);

  useEffect(() => {
    setUserData({
      id: user.id,
      name: user.name,
      email: user.email,
      document: user.additionalInformation.document,
      phone: user.additionalInformation.phone,
      birthdate: user.additionalInformation.birthdate
        ? formatDate(user.additionalInformation.birthdate, 'dd/MM/yyyy')
        : undefined,
      gender: user.additionalInformation.gender,
      address_id: user.additionalInformation.address?.id,
      zipcode: user.additionalInformation.address
        ? user.additionalInformation.address.zip_code
        : undefined,
      street: user.additionalInformation.address
        ? user.additionalInformation.address.street
        : undefined,
      number: user.additionalInformation.address
        ? user.additionalInformation.address.number?.toString()
        : undefined,
      neighborhood: user.additionalInformation.address
        ? user.additionalInformation.address.neighborhood
        : undefined,
      city: user.additionalInformation.address
        ? user.additionalInformation.address.city
        : undefined,
      state: user.additionalInformation.address
        ? user.additionalInformation.address.state
        : undefined,
      complement: user.additionalInformation.address
        ? user.additionalInformation.address.complement
        : undefined,
    });
    if (user.additionalInformation.gender) {
      setGenderSelected({
        id: user.additionalInformation.gender,
        value:
          user.additionalInformation.gender === 'M' ? 'Masculino' : 'Feminino',
      });
    }
  }, [user]);

  const handleChangeZipCode = useCallback(async (e) => {
    const { value } = e.target;
    if (value.length === 9) {
      const response = await axios.get(
        `https://viacep.com.br/ws/${value}/json/`
      );
      setUserData((state) => ({
        ...state,
        street: response.data.logradouro,
        neighborhood: response.data.bairro,
        city: response.data.localidade,
        state: response.data.uf,
        complement: response.data.complement,
      }));
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        setSending(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('O nome é obrigatório'),
          email: Yup.string().required('O e-mail é obrigatório'),
          document: Yup.string()
            .test('cpf', 'CPF inválido', (value) =>
              cpf.isValid(value as string)
            )
            .required('O CPF é obrigatório')
            .nullable(),
          phone: Yup.string().required('O telefone é obrigatório').nullable(),
          birthdate: Yup.string().required('O nascimento é obrigatório'),
          gender: Yup.string().required('O gênero é obrigatório'),
          zipcode: Yup.string().required('O CEP é obrigatório'),
          street: Yup.string().required('A rua é obrigatória'),
          number: Yup.string().required('O número é obrigatório'),
          neighborhood: Yup.string().required('O bairro é obrigatório'),
          city: Yup.string().required('A cidade é obrigatória'),
          state: Yup.string()
            .required('O estado é obrigatório')
            .test(
              'state',
              'Usar UF com 2 letras, exemplo: SP, RJ, SC',
              (value) => {
                if (!value) return true;
                return value.length === 2;
              }
            ),
          complement: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (documentError) {
          setSending(false);
          return;
        }

        const {
          name,
          email,
          document,
          phone,
          birthdate,
          gender,
          zipcode,
          street,
          number,
          neighborhood,
          state,
          city,
          complement,
        } = data;

        const formData = {
          name,
          email,
        };
        await api.put(`users/${user.id}`, formData);

        const addressFormData = {
          zip_code: zipcode,
          street,
          number,
          neighborhood,
          city,
          state,
          complement,
        };

        let address_id = user.additionalInformation.address?.id;
        if (user.additionalInformation.address) {
          const response = await api.put(
            `addresses/${user.additionalInformation.address.id}`,
            addressFormData
          );
          address_id = response.data.id;
        } else {
          const response = await api.post(`addresses`, addressFormData);
          address_id = response.data.id;
        }

        const athleteFormData = {
          user_id: user.id,
          address_id,
          document,
          phone,
          birthdate:
            birthdate &&
            birthdate.replaceAll('/', '-').split('-').reverse().join('-'),
          gender,
        };
        const response = await api.put(
          `additional-informations/${user.additionalInformation.id}`,
          athleteFormData
        );

        updateUser({
          ...user,
          id: user.id,
          name,
          email,
          additionalInformation: {
            ...user.additionalInformation,
            id: user.additionalInformation.id,
            document,
            phone,
            birthdate: response.data.birthdate,
            gender: genderSelected.id.toString(),
            verified: user.additionalInformation.verified,
            created_at: user.additionalInformation.created_at,
            address: {
              ...user.additionalInformation.address,
              id: address_id,
              zip_code: zipcode || '',
              street: street || '',
              number,
              neighborhood: neighborhood || '',
              state: state || '',
              city: city || '',
              complement: complement || '',
              country: user.additionalInformation.address
                ? user.additionalInformation.address.country
                : 'Brasil',
            },
          },
        });

        if (cart.isFillBeforeTicket === 1) {
          history.push(
            `${process.env.PUBLIC_URL}/eventos/${params.slug}/titularidade`
          );
        } else {
          history.push(
            `${process.env.PUBLIC_URL}/eventos/${params.slug}/resumo`
          );
        }

        Toast.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: 'Dados salvos!',
        });
        setSending(false);
      } catch (error) {
        setSending(false);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      } finally {
        setSending(false);
      }
    },
    [
      cart.isFillBeforeTicket,
      documentError,
      genderSelected.id,
      history,
      params.slug,
      updateUser,
      user,
    ]
  );

  const handleChangeDocument = useCallback(
    async (e) => {
      setDocumentError('');
      formRef.current?.setFieldError('document', '');
      const { value } = e.target;
      if (value.length === 14) {
        try {
          const response = await api.get(
            `additional-informations/document/${value}`
          );
          if (response.data && response.data.user_id !== user.id) {
            setDocumentError('Documento já cadastrado');
          }
        } catch (error) {
          // console.log(error);
        }
      }
    },
    [user.id]
  );

  return (
    <Container banner={banner}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-11 text-center pt-3">
            <div className="d-flex justify-content-between">
              <ButtonBack className="btn-back" />
              <ButtonHome />
            </div>
            <div className="banner my-3" />
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h2 className="h4 mb-0 d-flex align-items-center">
                <KrUserDocument
                  color="#FF6900"
                  size={20}
                  className="me-2 signin-icon"
                />
                Dados pessoais
              </h2>
            </div>
            <h4 className="text-start mb-3">
              Para seguir por favor preencha os dados pessoais abaixo
            </h4>
          </div>

          <div className="col-11">
            <Form
              ref={formRef}
              initialData={userData}
              onSubmit={handleSubmit}
              className="d-flex flex-column"
            >
              <label className="d-none mb-3">
                <span className="fw-normal d-block mb-2">Nome completo</span>
                <Input name="name" className="bd-input" />
              </label>
              <label className="d-none mb-3">
                <span className="fw-normal d-block mb-2">E-mail</span>
                <Input name="email" type="email" className="bd-input" />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">CPF</span>
                <InputMask
                  kind="custom"
                  options={{ mask: '999.999.999-99' }}
                  name="document"
                  className="bd-input"
                  value={userData.document}
                  error={documentError}
                  onChange={handleChangeDocument}
                />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Telefone</span>
                <InputMask
                  kind="cel-phone"
                  name="phone"
                  className="bd-input"
                  value={userData.phone}
                />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">
                  Data de nascimento
                </span>
                <InputMask
                  kind="custom"
                  options={{ mask: '99/99/9999' }}
                  name="birthdate"
                  className="bd-input"
                  value={userData.birthdate}
                  inputMode="numeric"
                />
              </label>
              <label className="">
                <span className="fw-normal d-block mb-2">Gênero</span>
                <InputRadio
                  name="gender"
                  className="d-flex justify-content-start check"
                  options={[
                    {
                      id: 'M',
                      value: 'Masculino',
                    },
                    {
                      id: 'F',
                      value: 'Feminino',
                    },
                  ]}
                  selected={genderSelected}
                  onChange={(e) => setGenderSelected(e)}
                />
              </label>
              <hr />
              <h2 className="h4 mt-2 mb-3">Endereço</h2>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">CEP</span>
                <InputMask
                  kind="custom"
                  options={{ mask: '99999-999' }}
                  name="zipcode"
                  className="bd-input"
                  value={userData.zipcode}
                  onChange={handleChangeZipCode}
                />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Endereço</span>
                <Input name="street" className="bd-input" />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Numero</span>
                <Input name="number" className="bd-input" />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Bairro</span>
                <Input name="neighborhood" className="bd-input" />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">Cidade</span>
                <Input name="city" className="bd-input" />
              </label>
              <label className="mb-3">
                <span className="fw-normal d-block mb-2">UF/ Estado</span>
                <Input name="state" className="bd-input" />
              </label>
              <label className="">
                <span className="fw-normal d-block mb-2">Complemento</span>
                <Input name="complement" className="bd-input" />
              </label>
              <button
                type="submit"
                disabled={sending}
                className="w-100 btn btn-login h6 fw-normal py-2 mt-4"
              >
                Salvar
              </button>
            </Form>
          </div>
        </div>
      </div>
      <Loading active={sizesLoaded} text="Carregando..." />
    </Container>
  );
};

export default PersonalData;
